module.exports = __webpack_public_path__ + "img/new-beni-box.d3cbda65.gif";